import axios from 'axios';
import { useContext, useEffect, useState } from "react";

import { Box, Button, Chip, Grid, IconButton, List, ListItemText, Modal, TextField, Tooltip, Typography, makeStyles, styled } from "@material-ui/core";
import RefreshIcon from '@material-ui/icons/Refresh';
import '../questions/index.css'

import WebcastingContext from "../../context/webcasting/webcastingContext";
import { submitLogs } from '../../config/AWSGlobalLog';

// function rand() {
//     return Math.round(Math.random() * 20) - 10;
// }

const CustomHeading = styled(Typography)(({ theme }) => ({
    fontSize: "2rem",
    textAlign: 'start',
    padding: '1rem',
    [theme.breakpoints.down("sm")]: {
        fontSize: '2rem'
    }
}));

// function getModalStyle() {
//     const top = 50 + rand();
//     const left = 50 + rand();

//     return {
//         position: "absolute",
//         top: "50%",
//         left: "50%",
//         transform: "translate(-50%, -50%)",
//         height: "auto",
//         width: "60%",
//         bgcolor: "background.paper",
//         // border: "2px solid #000",
//         boxShadow: 24,
//         p: 4,
//         zIndex: 9000,
//     };
// }

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        width: 400,
        backgroundColor: theme.palette.background.paper,
        // border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        height: "auto",
        width: "50%",
        bgcolor: "background.paper",
        // border: "2px solid #000",
        boxShadow: 24,
        zIndex: 9000,
        [theme.breakpoints.down("sm")]: {
            width: '70%',
            fontSize: '1rem'
        },
        [theme.breakpoints.up("md")]: {
            width: '70%',
        }, [theme.breakpoints.up("lg")]: {
            width: '50%',
        }
    },
}));

const HelpModal = ({ openHelpModal, handleCloseHelpModal }) => {

    const webcastingContext = useContext(WebcastingContext);
    const { sendQueryEmail, querySent, authorization, event, resetSendQuery } = webcastingContext
    console.log('authorizationFromPin', authorization?.dialInPin)
    const classes = useStyles();
    // const [modalStyle] = React.useState(getModalStyle);
    const [showHelpForm, setShowHelpForm] = useState(false)
    const [showDialIn, setShowDialIn] = useState(false)
    const [name, setName] = useState('')
    const [nameError, setNameError] = useState(false)
    const [email, setEmail] = useState('')
    const [emailError, setEmailError] = useState(false)
    const [query, setQuery] = useState('')
    const [queryError, setQueryError] = useState(false)
    const [dialInLoading, setDialInLoading] = useState(false)
    const [dialInError, setDialInError] = useState('')
    const [dialInPin, setDialInPin] = useState('')
    const [dialInRefreshMessage, setDialInRefreshMessage] = useState('')

    const usesSharedDialInPin = event?._id === '6ad0b96edac5bc001433bd6f';
    const rawDialInPin = usesSharedDialInPin
        ? '10689105'
        : authorization?.dialInPin;
    const normalizedDialInPin = rawDialInPin ? String(rawDialInPin).trim().padStart(8, '0') : '';
    const canShowDialIn = event?.assetType === 'audio' && event?.registrationRequired && /^\d{8}$/.test(normalizedDialInPin);

    useEffect(() => {
        if (querySent === 'sent') {
            // setHelp('ok')
            setName('')
            setEmail('')
            setQuery('')
        }
    }, [querySent])

    useEffect(() => {
        if (querySent === 'error') {
            const timer = setTimeout(() => resetSendQuery(), 4000)
            return () => clearTimeout(timer)
        }
    }, [querySent, resetSendQuery])

    useEffect(() => {
        // console.log('authorizationFromHelpModal', event, authorization)

        if (Object.entries(authorization).length > 0) {

            console.log('Is there name field help', Object.entries(authorization))

            if (Object.entries(authorization).length > 0) {
                if (authorization.hasOwnProperty("fields") && JSON.parse(authorization.fields)?.name) {
                    setName(JSON.parse(authorization.fields)?.name)
                }
            }

            if (event.registrationRequired) {
                setEmail(JSON.parse(authorization.fields)?.email)
            }
        }

    }, [authorization, querySent])

    let handleQuerySubmit = () => {

        if (!name) {
            setNameError(true)
        }

        if (!email) {
            setEmailError(true)
        }

        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
            setEmailError(true)
        }

        if (!query) {
            setQueryError(true)
        }

        if (!nameError && !emailError && !queryError) {
            //Send email

            sendQueryEmail({
                fromEmail: email,
                name: name,
                text: query,
                allFields: authorization.userData,
                eventTitle: event.title
            })
        }
        // setShowHelpForm(false)
    }

    let handleChangeName = (e) => {
        setNameError(false)
        setName(e.target.value)
    }

    let handleChangeEmail = (e) => {
        setEmailError(false)
        setEmail(e.target.value)
    }

    let handleChangeQuery = (e) => {
        setQueryError(false)
        setQuery(e.target.value)
    }

    let handleShowHelpForm = () => {
        setShowHelpForm(true)
        setQuery('')
        resetSendQuery('')
    }

    let handleShowHelpFormClose = () => {
        setShowHelpForm(false)
    }

    let handleSubmitAgain = () => {
        setQuery('')
        resetSendQuery('')
    }

    const logDialIn = (payload) => {
        submitLogs(JSON.stringify({
            element: 'HelpModal',
            feature: 'dial-in',
            eventId: event?._id,
            registrantId: authorization?._id,
            findId: authorization?.findId,
            ...payload
        }));
    };

    const resolveDialInUrl = () => {
        if (event?.isLive) {
            const streamUrl = event?.media?.audioStream?.url;
            const mountPoint = event?.media?.audioStream?.mountPoint;
            if (!streamUrl || !mountPoint) return '';
            return `${streamUrl}/${mountPoint}.mp3`;
        }
        return `${process.env.REACT_APP_ASSETS_BASE_URL}/${event?.media?.upload?.path || ''}`;
    };

    const sendUser = async (action = 'ATTEMPT') => {
        // The shared PIN is already registered; viewers must not overwrite its details.
        if (usesSharedDialInPin) return normalizedDialInPin;

        const name = deriveDisplayName(authorization?.fields) || 'N/A';
        const pin = normalizedDialInPin;
        const url = resolveDialInUrl();
        const eventId = event?._id;
        const eventTitle = event?.title;
        const isLive = event?.isLive;

        if (!canShowDialIn || !url || !eventId) {
            throw new Error('Dial-in details are not ready for this registration');
        }

        logDialIn({
            status: action,
            hasPin: Boolean(pin),
            hasUrl: Boolean(url),
            isLive
        });

        const twilioServiceUrl = (process.env.REACT_APP_TWILIO_SERVICE_URL || 'https://twilio.brrmedia.co.uk').replace(/\/+$/, '');

        await axios.post(`${twilioServiceUrl}/user`, { pin, url, eventId, eventTitle, isLive, name }, {
            headers: { 'Content-Type': 'application/json' }
        });

        logDialIn({
            status: 'SUCCESS',
            hasPin: Boolean(pin),
            hasUrl: Boolean(url),
            isLive
        });

        return pin;
    };

    let handleShowDialIn = async () => {
        if (dialInLoading) return;

        setDialInError('');
        setDialInRefreshMessage('');
        setDialInLoading(true);

        try {
            const pin = await sendUser('ATTEMPT');
            setDialInPin(pin);
            setShowDialIn(true);
        } catch (error) {
            const errorMessage = error?.response?.data?.error || error?.message || 'Unable to prepare dial-in details';
            setDialInError('Sorry, we could not prepare your dial-in details. Please try again or contact support.');
            logDialIn({
                status: 'ERROR',
                hasPin: Boolean(normalizedDialInPin),
                hasUrl: Boolean(resolveDialInUrl()),
                isLive: event?.isLive,
                error: errorMessage,
                statusCode: error?.response?.status
            });
        } finally {
            setDialInLoading(false);
        }
    }

    let handleRefreshDialInPin = async () => {
        if (dialInLoading) return;

        setDialInError('');
        setDialInRefreshMessage('Your PIN has expired');
        setDialInLoading(true);

        try {
            const pin = await sendUser('REFRESH');
            setDialInPin(pin);
            setDialInRefreshMessage('Your PIN has been refreshed. Please try dialling in again.');
        } catch (error) {
            const errorMessage = error?.response?.data?.error || error?.message || 'Unable to refresh dial-in details';
            setDialInRefreshMessage('');
            setDialInError('Your PIN has expired. We could not refresh it. Please try again or contact support.');
            logDialIn({
                status: 'REFRESH_ERROR',
                hasPin: Boolean(normalizedDialInPin),
                hasUrl: Boolean(resolveDialInUrl()),
                isLive: event?.isLive,
                error: errorMessage,
                statusCode: error?.response?.status
            });
        } finally {
            setDialInLoading(false);
        }
    }

    let handleCloseDialIn = () => {
        setShowDialIn(false)
    }

    function formatPin(pin) {
        // Ensure it's a string
        const strPin = String(pin);

        // Split it in half and join with a space
        const mid = Math.floor(strPin.length / 2);
        return strPin.slice(0, mid) + ' ' + strPin.slice(mid);
    }

    function deriveDisplayName(rawFields) {
        // rawFields can be a JSON string or an object
        let f = {};
        try {
            f = typeof rawFields === 'string' ? JSON.parse(rawFields) : (rawFields || {});
        } catch {
            f = {};
        }

        // Prefer explicit first_name / last_name
        const first =
            f.first_name || f.firstName || f.firstname ||
            // If there's a single "name", use its first word as "first name"
            (f.name ? String(f.name).trim().split(/\s+/)[0] : '');

        // Fallbacks
        let candidate =
            (first && String(first).trim()) ||
            (f.name && String(f.name).trim()) ||
            (f.email && String(f.email).split('@')[0]) ||
            '';

        // Final tidy: keep only first word if we somehow got a full name
        candidate = String(candidate).trim().split(/\s+/)[0] || 'Guest';

        // Light sanitize + cap length
        candidate = candidate.replace(/[^\p{L}\p{N}_-]/gu, '').slice(0, 64) || 'Guest';
        return candidate;
    }

    return (
        <>

            <Modal
                open={openHelpModal}
                onClose={handleCloseHelpModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <div className={classes.paper}>
                    <Typography variant='h4' className='title'>
                        Help & Support {showHelpForm && ' - Contact Form'} {showDialIn && ' - Listen-only number'}
                    </Typography>

                    {querySent === 'error' && (
                        <Grid container justifyContent={'center'} spacing={2} style={{ marginTop: '1rem' }}>
                            <Grid item xs={12} md={12} lg={12}>
                                <Typography className="description" style={{ color: 'red' }}>An error occurred while sending your email. Please try again later.</Typography>
                                </Grid>
                        </Grid>
                    )}

                    {!showHelpForm && !showDialIn &&
                        <Grid container justifyContent={'center'} spacing={2} style={{ marginTop: '1rem' }}>
                            <Grid item xs={12} md={12} lg={12}>
                                <Typography className="description">
                                    Our webcasts are compatible with a wide range of devices and operating systems without the
                                    need for any special software. If you are having any issues hearing/viewing the webcast,
                                    please try the following:
                                </Typography>
                                <List>
                                    <ListItemText
                                        classes={{ primary: 'description' }}
                                        primary="- Unmute the audio/video player or, if that doesn’t work" />
                                    <ListItemText
                                        classes={{ primary: 'description' }}
                                        primary="- Hard refresh your browser (to clear the cache) and unmute your audio/video player" />
                                    {canShowDialIn &&
                                        <Typography className="description">
                                            - Alternatively, if you are having trouble hearing the stream, click <span>
                                                <Chip className="description" onClick={handleShowDialIn} label={dialInLoading ? "Loading" : "Here"} disabled={dialInLoading} />
                                            </span> for your dial-in details to listen to the webcast over the phone
                                        </Typography>
                                    }
                                    {dialInError && !showDialIn &&
                                        <>
                                            <Typography className="description" style={{ color: '#c62828' }}>
                                                {dialInError}
                                            </Typography>
                                            {canShowDialIn &&
                                                <Box style={{ display: 'flex', justifyContent: 'center', marginTop: '0.5rem' }}>
                                                    <Button variant="contained" className="description" onClick={handleShowDialIn} disabled={dialInLoading}>
                                                        {dialInLoading ? 'Retrying...' : 'Retry'}
                                                    </Button>
                                                </Box>
                                            }
                                        </>
                                    }
                                    <Typography className="description">
                                        - If after these actions, you are still having issues, please get
                                        in touch with the team by clicking <span>
                                            <Chip className="description" onClick={handleShowHelpForm} label="Here" />
                                        </span>
                                    </Typography>
                                </List>
                                <Typography className="description">
                                    Thank you, the BRR Media webcast team.
                                </Typography>
                            </Grid>
                        </Grid>
                    }

                    {showHelpForm && <Grid container justifyContent={'center'} spacing={2} style={{ marginTop: '1rem' }}>
                        {querySent === 'sent' ?
                            <Grid item xs={12} md={12} lg={12}>
                                <Box style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
                                    <Typography className="description" style={{ color: 'gray', fontSize: "2rem", textAlign: 'center' }}>Your query has been sent</Typography>
                                </Box>
                                <Box style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
                                    {/* <Button className="description" variant="contained" onClick={handleSubmitAgain}>Submit Again </Button> */}
                                </Box>
                            </Grid>
                            :
                            <>
                                <Grid item xs={12} md={12} lg={12}>
                                    {
                                        Object.entries(authorization).length > 0 && authorization.hasOwnProperty("name") && <TextField
                                            disabled
                                            error={nameError} onChange={handleChangeName} value={name} helperText={nameError && "Enter you name"} label="Enter your name here" variant="outlined" style={{ width: '100%' }} />
                                    }
                                </Grid>

                                <Grid item xs={12} md={12} lg={12}>
                                    <TextField
                                        disabled={event.registrationRequired ? true : false}
                                        error={emailError} onChange={handleChangeEmail} value={email} helperText={emailError && "Email not valid"} type="email" label="Enter your email here" variant="outlined" style={{ width: '100%' }} />
                                </Grid>

                                <Grid item xs={12} md={12} lg={12}>
                                    <TextField
                                        error={queryError} onChange={handleChangeQuery} value={query} helperText={queryError && "Enter your query"} multiline rows={4} label="Enter your query here" variant="outlined" style={{ width: '100%' }} />
                                </Grid>

                                <Box direction={'row'} style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }} spacing={2} m={2}>
                                    <Button variant="contained" className="description" onClick={handleQuerySubmit}>Send</Button>
                                    <Button variant="contained" className="description" onClick={handleShowHelpFormClose}>Back</Button>
                                </Box>
                            </>
                        }
                    </Grid>
                    }

                    {showDialIn && <Grid container justifyContent={'center'} spacing={2} style={{ marginTop: '1rem' }}>
                        <Grid item xs={12} md={12} lg={12}>
                            <Typography className="description">Tel: <a style={{ color: "#fb7800", textDecoration: "none" }} href="tel:+442030041500"><b>+44 203 004 1500</b></a></Typography>
                            <Box style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
                                <Typography className="description">
                                    PIN:<b> {formatPin(dialInPin)}</b>
                                </Typography>
                                {!usesSharedDialInPin && <Tooltip title="Refresh PIN">
                                    <span>
                                        <IconButton
                                            aria-label="Refresh PIN"
                                            onClick={handleRefreshDialInPin}
                                            disabled={dialInLoading}
                                            size="small"
                                            style={{ color: '#fb7800' }}
                                        >
                                            <RefreshIcon />
                                        </IconButton>
                                    </span>
                                </Tooltip>}
                            </Box>
                            {dialInRefreshMessage &&
                                <Typography className="description" style={{ color: dialInRefreshMessage === 'Your PIN has expired' ? '#c62828' : '#2e7d32' }}>
                                    {dialInRefreshMessage}
                                </Typography>
                            }
                            {dialInError &&
                                <Typography className="description" style={{ color: '#c62828' }}>
                                    {dialInError}
                                </Typography>
                            }
                        </Grid>
                        <Box direction={'row'} style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }} spacing={2} m={2}>
                            <Button variant="contained" className="description" onClick={handleCloseDialIn}>Back</Button>
                        </Box>
                    </Grid>
                    }
                </div>
            </Modal>
        </>
    )
}

export default HelpModal
